<template>
    <section>
        <!-- Loading -->
        <loading />

        <div class="module-content">
            <!-- Booking Content -->
            <div v-if="!showpdpbooking" class="content booking-list">
                <div class="icon-text-wrapper mb-tablet-only">
                    <p
                        @click="showSidebarMenu()"
                        role="button"
                        class="button-body"
                    >
                        Perfil
                    </p>
                </div>

                <h1 class="title-content heading-4">Reservas</h1>

                <!-- Booking Buttons -->
                <div class="first-content">
                    <div class="all-buttons">
                        <span
                            v-for="(value, index) in buttonsListName"
                            :key="index"
                            @click="buttonsActions($event)"
                            role="button"
                            :data-action="value.action"
                            :class="
                                referenceturnbackcontent === value.action
                                    ? `module-button activebk ${value.action}-button me-2`
                                    : `module-button ${value.action}-button me-2`
                            "
                        >
                            <p :data-action="value.action">{{ value.name }}</p>
                        </span>
                    </div>

                    <div class="filter-option" data-indicate="date">
                        <label class="date-wrapper">
                            <input
                                ref="dateInput"
                                type="date"
                                class="form-control"
                                :min="dateInputCurrentYear"
                                :max="dateInputToday"
                                placeholder="dd-mm-yyyy"
                                id="date"
                                v-model="dateInputValue"
                                @change="filterValueByDate($event)"
                            />
                            <span
                                class="overlay"
                                @click="openDatePicker"
                            ></span>
                        </label>

                        <button
                            role="button"
                            class="btn btn-filled-blue button-body"
                            @click="cleanFilter()"
                            :disabled="disabledfilter"
                        >
                            Limpar
                        </button>
                    </div>
                </div>

                <hr />

                <!-- Booking List -->
                <template
                    v-if="
                        (Object.hasOwn(bookingData, 'current') &&
                            Object.values(bookingData.current).length > 0) ||
                        (Object.hasOwn(bookingData, 'old') &&
                            Object.values(bookingData.old).length > 0)
                    "
                >
                    <!-- Booking Data -->
                    <div class="second-content">
                        <template
                            v-for="(
                                valcontent, indexcontent
                            ) in contentListIndicate"
                            :key="indexcontent"
                        >
                            <div
                                v-if="
                                    Object.values(bookingData[valcontent])
                                        .length > 0
                                "
                                :class="
                                    referenceturnbackcontent === valcontent
                                        ? `booking-content ${valcontent}-content`
                                        : `booking-content ${valcontent}-content desactivebk`
                                "
                                :data-action="valcontent"
                            >
                                <div
                                    v-for="(value, index) in setBookingData(
                                        valcontent
                                    )"
                                    :key="index"
                                    class="booking-card"
                                    role="button"
                                    aria-describedby="Booking Card"
                                    :data-referindex="index"
                                    :data-index="value.office_id"
                                    :data-action="valcontent"
                                    @click="showBookingDetails($event)"
                                >
                                    <div
                                        class="booking-img"
                                        :data-action="valcontent"
                                        :data-referindex="index"
                                        @click="showBookingDetails($event)"
                                    >
                                        <img
                                            :data-action="valcontent"
                                            :data-referindex="index"
                                            :src="
                                                value.image[0].thumbexist
                                                    ? value.image[0]
                                                          .media_middle
                                                    : value.image[0]
                                                          .media_original
                                            "
                                            :alt="`${value.office_name} Image`"
                                        />
                                    </div>

                                    <div
                                        class="booking-info"
                                        :data-action="valcontent"
                                        :data-referindex="index"
                                        @click="showBookingDetails($event)"
                                    >
                                        <h6 class="booking-info-office-name">
                                            {{
                                                resumeMessage(
                                                    value.office_name,
                                                    18
                                                )
                                            }}
                                        </h6>

                                        <div class="icon-text-wrapper">
                                            <p class="booking-info-date">
                                                {{
                                                    `${value.day} de ${
                                                        customData.calendardata
                                                            .allmonths[
                                                            `${value.month}`
                                                        ]
                                                    } de ${value.year}`
                                                }}
                                            </p>
                                        </div>

                                        <div class="icon-text-wrapper">
                                            <div
                                                class="d-flex flex-row flex-wrap"
                                            >
                                                <p
                                                    v-for="(
                                                        valturn, indexturn
                                                    ) in value.turndatalist"
                                                    :key="indexturn"
                                                    class="schedule-info-time"
                                                >
                                                    {{
                                                        `${valturn.begin}:00 - ${valturn.end}:00`
                                                    }}
                                                </p>
                                            </div>
                                        </div>

                                        <div class="id-text-wrapper">
                                            <small class="body-1">
                                                <span class="body-1">ID: </span>
                                                {{
                                                    ` ${value.manage_booking_id}`
                                                }}</small
                                            >
                                        </div>

                                        <div
                                            class="booking-info-request"
                                            v-if="
                                                Array.isArray(
                                                    value.feddback_data
                                                ) && valcontent === 'current'
                                            "
                                            :id="`feedback_response_${value.office_id}`"
                                        >
                                            <span class="strong-500 body-1">
                                                {{
                                                    formResponse(
                                                        value.feddback_data,
                                                        `feedback_response_${value.office_id}`
                                                    )
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-else
                                :class="
                                    referenceturnbackcontent === valcontent
                                        ? `d-flex flex-column booking-callback-content booking-content ${valcontent}-content`
                                        : `d-flex flex-column booking-callback-content booking-content ${valcontent}-content desactivebk`
                                "
                                :data-action="valcontent"
                            >
                                <p>{{ setCallbackMessage(valcontent) }}</p>
                            </div>
                        </template>
                    </div>
                </template>

                <template v-else>
                    <div class="booking-callback-content">
                        <p>Ainda não tem reservass</p>

                        <a
                            :href="customData.plp"
                            target="_self"
                            class="btn btn-primary btn-filled-blue button-body"
                            role="button"
                            aria-describedby="Find Offices"
                            >Encontrar espaços</a
                        >
                    </div>
                </template>
            </div>

            <!-- Pdp Booking Content -->
            <div v-if="showpdpbooking" class="pdp-booking-content content">
                <!-- First Content -->
                <div class="first-content">
                    <div @click="turnBack()" role="button" class="turnback">
                        <div class="icon-text-wrapper">
                            <p class="button-body go-back-icon">Reservas</p>
                        </div>
                    </div>

                    <div class="flex-wrapper">
                        <h6 class="title-content">
                            {{ pdpbookingdata.date }}
                        </h6>

                        <span class="body-1">
                            <span class="body-1 color-text-action strong-500"
                                >ID: </span
                            >{{ ` ${pdpbookingdata.manage_booking_id}` }}</span
                        >
                    </div>
                </div>

                <hr />

                <!-- Second Content -->
                <div class="second-content second-content-pdp-booking-content">
                    <div class="icon-text-wrapper">
                        <p class="button-body location-icon">
                            {{ pdpbookingdata.address }}
                        </p>
                    </div>

                    <figure>
                        <figcaption>
                            <strong>{{ pdpbookingdata.name }}</strong>
                        </figcaption>

                        <img
                            :src="pdpbookingdata.image"
                            :alt="pdpbookingdata.name"
                        />
                    </figure>
                </div>

                <hr />

                <!-- Third Content -->
                <div class="third-content">
                    <p class="strong-600">Detalhes das reservas:</p>

                    <ul class="list-group booking-details" ref="bookingdetails">
                        <li
                            v-for="(
                                valpdp, indexpdp
                            ) in pdpbookingdata.turndatalist"
                            :key="indexpdp"
                            class="list-group-item turnpdpitem"
                            :class="indexpdp === 0 ? 'turnselected' : ''"
                            :data-bookingid="valpdp.booking_id"
                            :data-referindex="indexpdp"
                            @click="setRequestDataByBooking($event)"
                        >
                            <div class="booking-detail-card">
                                <div class="content-wrapper">
                                    <div class="hour">
                                        <p class="hour-info">
                                            {{
                                                `${valpdp.begin}:00 - ${valpdp.end}:00`
                                            }}
                                        </p>
                                    </div>

                                    <div class="subtotal">
                                        <p>
                                            {{ `Total: ${valpdp.subtotal} € ` }}
                                        </p>
                                        <p class="caption-md color-text-body">
                                            {{ ` / ${valpdp.totalhour} horas` }}
                                        </p>
                                    </div>
                                </div>

                                <div
                                    v-if="showeditcontainer"
                                    class="edit-container"
                                >
                                    <!-- btn-info -->
                                    <button
                                        type="button"
                                        class="btn btn-changedate button-body"
                                        aria-label="Edit Booking"
                                        @click="
                                            showModal(
                                                'editbookingmodal',
                                                valpdp
                                            )
                                        "
                                    >
                                        <span></span>Alterar data
                                    </button>
                                </div>

                                <div
                                    v-if="valpdp.billing_id !== null"
                                    class="icon-text-wrapper"
                                >
                                    <span></span>
                                    <a
                                        :href="valpdp.billing_pdf"
                                        target="_blank"
                                        class="button-body invoice-download"
                                        download="Fatura"
                                        rel="noopener noreferrer"
                                    >
                                        Fatura
                                    </a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <hr />

                <!-- Fourth Content | Forms -->
                <!-- Current Booking -->
                <div
                    :class="
                        pdpbookingdata.typeofbooking === 'current'
                            ? 'd-flex'
                            : 'd-none'
                    "
                    class="fourth-content d-flex flex-column"
                >
                    <div class="specialrequestbase" ref="specialrequestbase">
                        <div class="specialrequest-content">
                            <p class="strong-600">
                                Política de edição de reservas
                            </p>

                            <p class="caption-lg color-text-body">
                                A edição da reserva deverá possuir como total de
                                horas a mesma quantidade de horas adquiridas em
                                sua marcação. A edição da reserva deverá ser
                                feita com antecedência mínima de
                                {{ customData.edit.value }} horas.
                            </p>
                        </div>

                        <div class="specialrequest-content">
                            <p class="strong-600">Política de cancelamento</p>

                            <p class="caption-lg color-text-body">
                                Os cancelamentos deverão ser efetuados com uma
                                antecedência mínima de
                                {{ customData.request.value }} horas. Em caso de
                                ausência não comunicada, poderá perder o valor
                                total da reserva
                            </p>
                        </div>

                        <div class="specialrequest-content">
                            <div
                                class="d-flex flex-row justify-content-between"
                            >
                                <p class="strong-600">Formulário de contacto</p>
                                <p class="strong-500" style="color: #346cf0">
                                    {{ requestBookingTurnReference }}
                                </p>
                            </div>

                            <p class="caption-lg color-text-body">
                                Utilize o formulário abaixo para gerir ou
                                cancelar a tua reserva
                            </p>
                        </div>

                        <div class="specialrequest-content">
                            <form
                                @submit.prevent="sendData('special_request')"
                                action=""
                                method="post"
                                autocomplete="on"
                                aria-describedby="Special Request Form"
                            >
                                <div class="inputs-flex-wrapper">
                                    <label
                                        for="subject"
                                        class="form-label body-1 strong-600"
                                        >Assunto</label
                                    >

                                    <select
                                        id="subject"
                                        v-model="subject"
                                        class="form-select"
                                        aria-label="Special Request Options"
                                    >
                                        <option
                                            v-for="(
                                                val, index
                                            ) in specialRequestOptions"
                                            :key="val.id"
                                            :value="val.id"
                                            :data-referindex="index"
                                            :selected="
                                                val.id === 1 ? true : false
                                            "
                                            class="body-1"
                                        >
                                            {{ val.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="inputs-flex-wrapper">
                                    <label
                                        for="message"
                                        class="form-label body-1 strong-600"
                                        >Mensagem</label
                                    >

                                    <textarea
                                        class="form-control body-1"
                                        @focusin="
                                            inputValidationCase(
                                                'message',
                                                $event
                                            )
                                        "
                                        @focusout="
                                            inputValidationCase(
                                                'message',
                                                $event
                                            )
                                        "
                                        v-model="message"
                                        id="message"
                                        maxlength="400"
                                    >
                                    </textarea>

                                    <p class="caption-md color-text-body">
                                        *A mensagem pode ter até 400 caracteres.
                                    </p>
                                </div>

                                <div
                                    class="d-flex flex-row justify-content-end"
                                >
                                    <button
                                        type="submit"
                                        class="btn btn-primary btn-filled-blue submit-btn"
                                        :disabled="disabledspecialrequest"
                                    >
                                        Enviar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="requestresponsebase" ref="requestresponsebase">
                        <h3 class="strong-600 section-title body-1">
                            Pedidos do utilizador
                        </h3>

                        <!-- Request Response -->
                        <div class="third-content">
                            <div
                                v-if="
                                    Array.isArray(
                                        pdpbookingdata.response_request
                                    )
                                "
                                class="third-content-container d-flex flex-column"
                            >
                                <!-- Card Info -->
                                <div
                                    v-for="(
                                        value, index
                                    ) in pdpbookingdata.response_request"
                                    :key="index"
                                    class="third-content-card d-flex flex-column"
                                >
                                    <div
                                        role="button"
                                        class="first-line"
                                        @click="showHideRequest($event)"
                                    >
                                        <div class="first-line-title">
                                            <p
                                                class="strong-500 color-text-action heading-6"
                                            >
                                                {{
                                                    `${getRequestStatus(
                                                        value.data.subject
                                                    )} `
                                                }}
                                                <span class="two-dots">:</span>
                                                &nbsp;
                                            </p>
                                            <small class="body-1">
                                                {{
                                                    `  para ${value.data.booking.date}  `
                                                }}
                                                &nbsp;</small
                                            >
                                            <div
                                                :class="`body-1 ${statusClassname(
                                                    value.form_status
                                                )}`"
                                            >
                                                {{ value.form_status }}
                                            </div>
                                        </div>

                                        <img
                                            :src="`${defaultpathimg}/keyboard_arrow_down_blue.svg`"
                                            alt="Filter Icon"
                                            class="icon-request"
                                        />
                                    </div>

                                    <div
                                        v-if="!value.not_response_form"
                                        class="request-content d-none"
                                    >
                                        <div class="second-line">
                                            <div
                                                class="d-flex justify-content-between"
                                            >
                                                <span
                                                    class="body-1 color-text-body"
                                                    >Mensagem:
                                                </span>
                                                <span
                                                    class="body-1 color-text-body"
                                                    >{{
                                                        value.created_at
                                                    }}</span
                                                >
                                            </div>

                                            <p class="message">
                                                {{ value.data.message }}
                                            </p>
                                        </div>

                                        <div class="second-line-v-else">
                                            <div
                                                class="d-flex justify-content-between"
                                            >
                                                <span
                                                    class="body-1 color-text-body"
                                                    >Resposta:
                                                </span>
                                                <span
                                                    class="caption-lg color-text-body"
                                                    >{{
                                                        value.updated_at
                                                    }}</span
                                                >
                                            </div>
                                            <p class="message">
                                                {{ value.form_response }}
                                            </p>
                                        </div>
                                    </div>

                                    <div v-else class="request-content">
                                        <div class="second-line">
                                            <div
                                                class="d-flex justify-content-between"
                                            >
                                                <span
                                                    class="body-1 color-text-body"
                                                    >Mensagem:
                                                </span>
                                                <span
                                                    class="body-1 color-text-body"
                                                    >{{
                                                        value.created_at
                                                    }}</span
                                                >
                                            </div>

                                            <p class="message">
                                                {{ value.data.message }}
                                            </p>
                                        </div>

                                        <div class="second-line-v-else">
                                            <p class="color-text-body">
                                                Sua solicitação ainda não obteve
                                                resposta
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <p class="color-text-body no-requests-msg">
                                    Esta reserva não possui pedidos
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Old Booking -->
                <div
                    :class="
                        pdpbookingdata.typeofbooking === 'old' && enablefeedback
                            ? 'd-flex'
                            : 'd-none'
                    "
                    class="fourth-content"
                >
                    <div
                        v-if="!pdpbookingdata.feedback_response"
                        class="feedbackbase"
                        ref="feedbackbase"
                    >
                        <div class="feedbackbase-items-wrapper">
                            <p class="strong-600">Como foi tua experiência ?</p>

                            <div class="feedback-list">
                                <div
                                    v-for="(val, index) in feedbackQuestion"
                                    :key="index"
                                    class="feedbackitens"
                                    :data-value="val.value"
                                    data-action="experience"
                                    @click="feedbackButtons($event)"
                                >
                                    <div
                                        class="feedbackitens-value"
                                        data-action="experience"
                                        :data-value="val.value"
                                    >
                                        <div
                                            class="symbolelement"
                                            :id="`symbolelement-${index}`"
                                            :data-symbolvalue="
                                                val.route.pdp.symbol
                                            "
                                            :data-value="val.value"
                                            data-action="experience"
                                            ref="symbolelement"
                                        >
                                            <span
                                                data-action="experience"
                                                :data-value="val.value"
                                                v-html="val.route.pdp.symbol"
                                            ></span>
                                        </div>
                                        <p
                                            class="caption-md"
                                            data-action="experience"
                                            :data-value="val.value"
                                        >
                                            {{ val.route.pdp.text.pt }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="feedbackbase-items-wrapper">
                            <p class="strong-600">Recomendaria este espaço ?</p>

                            <div class="feedback-question">
                                <div
                                    @click="feedbackButtons($event)"
                                    data-action="recommend"
                                    data-value="2"
                                    class="feedback-item"
                                >
                                    <p
                                        data-action="recommend"
                                        class="button-body"
                                        data-value="2"
                                    >
                                        Não
                                    </p>
                                </div>

                                <div
                                    @click="feedbackButtons($event)"
                                    data-action="recommend"
                                    data-value="1"
                                    class="feedback-item"
                                >
                                    <p
                                        data-action="recommend"
                                        class="button-body"
                                        data-value="1"
                                    >
                                        Sim
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="feedbackbase-items-wrapper">
                            <p class="strong-600">
                                O espaço estava de acordo com o descrito ?
                            </p>

                            <div class="feedback-question">
                                <div
                                    @click="feedbackButtons($event)"
                                    data-action="described"
                                    data-value="2"
                                    class="feedback-item"
                                >
                                    <p
                                        data-action="described"
                                        class="button-body"
                                        data-value="2"
                                    >
                                        Não
                                    </p>
                                </div>

                                <div
                                    @click="feedbackButtons($event)"
                                    data-action="described"
                                    data-value="1"
                                    class="feedback-item"
                                >
                                    <p
                                        data-action="described"
                                        class="button-body"
                                        data-value="1"
                                    >
                                        Sim
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="feedbackbase-items-wrapper">
                            <p class="strong-600">
                                O espaço estava bem higienizado ?
                            </p>

                            <div class="feedback-question">
                                <div
                                    @click="feedbackButtons($event)"
                                    data-action="cleaned"
                                    data-value="2"
                                    class="feedback-item"
                                >
                                    <p
                                        data-action="cleaned"
                                        class="button-body"
                                        data-value="2"
                                    >
                                        Não
                                    </p>
                                </div>

                                <div
                                    @click="feedbackButtons($event)"
                                    data-action="cleaned"
                                    data-value="1"
                                    class="feedback-item"
                                >
                                    <p
                                        data-action="cleaned"
                                        class="button-body"
                                        data-value="1"
                                    >
                                        Sim
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="feedbackbase-items-wrapper-check">
                            <p class="strong-600">
                                Que funcionalidades gostavas de ter ?
                            </p>

                            <div class="feedback-question">
                                <div
                                    class="feedback-checkbox form-check form-check-inline"
                                    v-for="(
                                        val, index
                                    ) in feedbackFeauturesQuestion"
                                    :key="index"
                                >
                                    <input
                                        @click="feedbackButtons($event)"
                                        class="form-check-input"
                                        type="checkbox"
                                        data-action="features"
                                        :data-value="index"
                                        :id="`feedback-checkbox-${index}`"
                                        :value="index"
                                    />
                                    <label
                                        class="form-check-label button-body"
                                        data-action="features"
                                        :data-value="index"
                                        >{{ val }}</label
                                    >
                                </div>
                            </div>

                            <p class="caption-lg color-text-body" role="small">
                                *Caso tenha alguma sugestão ou melhoria a
                                apontar que não conste nesta lista entre em
                                contacto por:
                                <a
                                    href="mailto:email@email.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Send Support Mail"
                                    >email@email.com</a
                                >
                            </p>
                        </div>

                        <div class="feedback-button">
                            <button
                                @click="sendData('feedback')"
                                type="button"
                                class="btn btn-primary btn-filled-blue button-body"
                                :disabled="disabled"
                            >
                                Enviar
                            </button>
                        </div>
                    </div>

                    <div v-else>
                        <h6>
                            Agradecemos pelo seu feedback, graças a sua
                            contribuição continuaremos a melhorar nossa
                            plataforma para o melhor atendê-lo(a).
                        </h6>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edit Booking Modal -->
        <modal
            title=""
            classname="editbookingmodal"
            :hidemodalfunction="hideModal"
        >
            <template #modalcontent>
                <div class="flex-wrapper-class">
                    <div class="addnewdaymodal-item search-period-wrapper">
                        <div
                            @click="getHourOrPeriodForAddNewDayReserve($event)"
                            class="addnewdaychooselist"
                        ></div>
                    </div>

                    <calendar-element
                        classnamebase="addnewdaymodal-item"
                        :calendardata="customData.calendardata"
                        tdclassname="addnewweekday"
                        @select_date="dynamicGetSelectDate($event)"
                        :allmonths="customData.calendardata.allmonths"
                        calendartype="newday"
                    />

                    <div
                        class="addnewdaymodal-item search-modal-action-btns modal-footer"
                    >
                        <button
                            @click="editBooking()"
                            type="button"
                            class="btn btn-confirm btnaddnewday btn-filled-blue w-100 button-body"
                            id="addnew-day"
                            :disabled="disablededitbooking"
                        >
                            Alterar data
                        </button>

                        <button
                            @click="hideModal('editbookingmodal')"
                            type="button"
                            class="btn btn-cancel w-100 button-body"
                            data-bs-dismiss="modal"
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            </template>
        </modal>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </section>
</template>
<script>
import fetchData from "./../../../../fetchData.js";
import ListMessage from "./../../../elements/ListMessageElement.vue";
import Loading from "./../../../elements/LoadingElement.vue";
import responseMessage from "./../../../../responseMessage";
import inputValidation from "./../../../../validationInputs.js";
import defaultWebsite from "./../../../../defaultWebsiteScript.js";
import Modal from "./../../../elements/ModalElement.vue";
import CalendarElement from "./../../../elements/CalendarElement.vue";
import calendarRoutine from "./../../../../calendarScript.js";

//Set Use Strict
("use strict");

export default {
    name: "Booking",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        customdata: {
            type: String,
            required: true,
        },
        bookingdata: {
            type: String,
            required: true,
        },
        enablefeedback: {
            type: String,
            required: true,
        },
        feedbackquestion: {
            type: String,
            required: true,
        },
        feedbackurl: {
            type: String,
            required: true,
        },
        feedbackfeauturesquestion: {
            type: String,
            required: true,
        },
        specialrequestoptions: {
            type: String,
            required: true,
        },
        imgdefaultpath: {
            type: String,
            required: true,
        },
        defaultpathimg: {
            type: String,
            required: true,
        },
        typeofrequest: {
            type: String,
            required: true,
        },
        editurl: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            message: "",
            subject: "",
            disabledspecialrequest: true,
            activeclass: "d-flex",
            disabled: true,
            bookingData: {},
            customData: {},
            currentBooking: [],
            oldBooking: [],
            pastdaysBooking: [],
            cancelBooking: [],
            showpdpbooking: false,
            pdpbookingdata: {
                id: "",
                booking_id: "",
                day: "",
                date: "",
                address: "",
                name: "",
                image: "",
                data: {
                    begin: "",
                    end: "",
                    subtotal: "",
                    totalhour: "",
                },
                turndatalist: [],
                total: "",
                typeofbooking: "",
            },
            feedbackQuestion: {},
            feedbackFeauturesQuestion: {},
            feedbackdata: {
                data: {
                    experience: "",
                    recommend: "",
                    described: "",
                    cleaned: "",
                    features: [],
                    booking: {
                        day: "",
                        date: "",
                        begin: "",
                        end: "",
                    },
                },
                type: "feedback",
                office_id: "",
                booking_id: "",
            },
            specialRequestOptions: {},
            limitwidthbackoffice: 1180,
            pdpbookingfeedbackrefer: {
                office_id: [],
                days: [],
            },
            referenceturnbackcontent: "current",
            requeststatus: [],
            dateInputToday: "",
            dateInputCurrentYear: "",
            dateInputValue: "",
            filterSelected: {
                bookingstatus: {
                    data: [],
                    total: 0,
                },
                requeststatus: {
                    data: [],
                    total: 0,
                },
                dateInputValue: 0,
                totalfilter: 0,
            },
            filterData: [],
            date: {},
            oldreferBookingData: [],
            currentreferBookingData: [],
            cancelreferBookingData: [],
            buttonsListName: [
                {
                    id: 1,
                    name: "Ativas",
                    action: "current",
                },
                {
                    id: 2,
                    name: "Passadas",
                    action: "old",
                },
                {
                    id: 3,
                    name: "Canceladas",
                    action: "cancel",
                },
            ],
            contentListIndicate: ["current", "old", "cancel"],
            disabledfilter: true,
            responseTimeOut: 10000,
            requestBookingTurnReference: "",
            editbooking: {
                reserver: {},
                searchtype: 1,
                turndata: {
                    type: null,
                    datahour: {
                        begin: null,
                        end: null,
                    },
                    data: {},
                },
            },
            bookingReference: {},
            interval: [],
            customDays: [],
            disablededitbooking: false,
            showeditcontainer: true,
        };
    },
    created() {
        //Set Data
        this.customData = JSON.parse(this.customdata);
        this.bookingData = JSON.parse(this.bookingdata);

        //Set Request Status
        this.requeststatus = JSON.parse(this.typeofrequest);

        //Set Checkout Feedback
        this.feedbackQuestion = JSON.parse(this.feedbackquestion);
        this.feedbackFeauturesQuestion = JSON.parse(
            this.feedbackfeauturesquestion
        );
        this.specialRequestOptions = JSON.parse(this.specialrequestoptions);

        //Check Booking Data
        if (
            Object.hasOwn(this.bookingData, "current") &&
            Object.hasOwn(this.bookingData, "old")
        ) {
            //Separate Data by Current and Old
            ["current", "old", "pastdays", "cancel"].forEach((value) => {
                //Get Booking Data
                this.bookingData[value].forEach((valbooking) => {
                    if (Array.isArray(valbooking.booking_data)) {
                        valbooking.booking_data.forEach((valturn) => {
                            //Set Booking Data
                            valturn["image"] = valbooking.media_data;
                            valturn["all_begin_hour"] = [
                                valturn.turndata.begin,
                            ];
                            valturn["all_end_hour"] = [valturn.turndata.end];
                            //Associated Turndata by booking_id
                            valturn.turndata.booking_id = valbooking.booking_id;
                            valturn["turndatalist"] = [valturn.turndata];

                            //Set Booking Id
                            valturn["booking_id"] = valbooking.booking_id;
                            valturn["manage_booking_id"] =
                                valbooking.manage_booking_id;

                            //Set Billing data
                            valturn.turndata.billing_id = valbooking.billing_id;
                            valturn.turndata.billing_pdf =
                                valbooking.billing_pdf;

                            //Set Feedback Data only for Current Booking
                            if (Object.hasOwn(this.bookingData, "current")) {
                                valturn["feddback_data"] =
                                    valbooking.feddback_data;
                            }

                            //Associated Data
                            if (Object.hasOwn(this.$data, `${value}Booking`)) {
                                if (
                                    this.$data[`${value}Booking`].length === 0
                                ) {
                                    this.$data[`${value}Booking`].push(valturn);
                                } else {
                                    //Check Day - valturn
                                    let dayExist = this.$data[
                                        `${value}Booking`
                                    ].find(
                                        (valday) =>
                                            valday.day === valturn.day &&
                                            valday.month === valturn.month &&
                                            valday.year === valturn.year &&
                                            valday.office_id ===
                                                valturn.office_id
                                    );

                                    if (dayExist === undefined) {
                                        this.$data[`${value}Booking`].push(
                                            valturn
                                        );
                                    } else {
                                        //Get Index
                                        let indexDay =
                                            this.$data[
                                                `${value}Booking`
                                            ].indexOf(dayExist);

                                        //Set Booking Turndata
                                        this.$data[`${value}Booking`][indexDay][
                                            "all_begin_hour"
                                        ].push(valturn.turndata.begin);
                                        this.$data[`${value}Booking`][indexDay][
                                            "all_end_hour"
                                        ].push(valturn.turndata.end);
                                        this.$data[`${value}Booking`][indexDay][
                                            "turndatalist"
                                        ].push(valturn.turndata);

                                        this.$data[`${value}Booking`][indexDay][
                                            "all_begin_hour"
                                        ] = [
                                            ...new Set(
                                                this.$data[`${value}Booking`][
                                                    indexDay
                                                ]["all_begin_hour"]
                                            ),
                                        ];
                                        this.$data[`${value}Booking`][indexDay][
                                            "all_end_hour"
                                        ] = [
                                            ...new Set(
                                                this.$data[`${value}Booking`][
                                                    indexDay
                                                ]["all_end_hour"]
                                            ),
                                        ];
                                    }
                                }
                            }
                        });
                    } else {
                        valbooking.booking_data.image = valbooking.media_data;
                        valbooking.booking_data.all_begin_hour = [
                            valbooking.booking_data.turndata.begin,
                        ];
                        valbooking.booking_data.all_end_hour = [
                            valbooking.booking_data.turndata.end,
                        ];
                        valbooking.booking_data.turndatalist = [
                            valbooking.booking_data.turndata,
                        ];
                        valbooking.booking_data.booking_id =
                            valbooking.booking_id;
                        valbooking.booking_data.manage_booking_id =
                            valbooking.manage_booking_id;

                        this.$data[`${value}Booking`].push(
                            valbooking.booking_data
                        );
                    }
                });
            });

            //Check Past Days
            /*if (
                Object.hasOwn(this.bookingData, "pastdays") &
                    (this.bookingData.pastdays.length > 0) &&
                this.oldBooking.length > 0 || this.oldBooking.length === 0
            ) {
                this.oldBooking = this.oldBooking.concat(
                    this.pastdaysBooking
                );

                if(this.bookingData.pastdays.length > 0){
                    this.bookingData.old.push(this.oldBooking);
                }
            }*/
        }

        //Set Current Year
        this.date = new Date();

        const ultimoDiaDoMes = new Date(
            this.date.getFullYear(),
            this.date.getMonth() + 1,
            0
        );

        //Set Last Day of Current Month
        this.dateInputToday =
            parseInt(this.date.getFullYear()) +
            1 +
            "-" +
            12 +
            "-" +
            ultimoDiaDoMes.getDate();

        //Set Only Date from Current Year
        this.dateInputCurrentYear = this.date.getFullYear() + "-01-01";
    },
    //perguntar
    mounted() {
        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        editBooking() {
            //Check begin and end hour
            switch (this.editbooking.turndata.type) {
                //hour
                case "hour":
                    if (
                        this.editbooking.turndata.datahour.begin === null ||
                        this.editbooking.turndata.datahour.end === null ||
                        !calendarRoutine.checkValuesBeforeSend(
                            this.editbooking.turndata.datahour.begin,
                            this.editbooking.turndata.datahour.end,
                            "select-turn-morning-addnewday",
                            "select-turn-affternoon-addnewday"
                        )
                    ) {
                        //Render Response Message
                        responseMessage.renderResponseMessages(
                            this.$refs.responsebasemessage,
                            "warning",
                            "Os dados enviados não são válidos",
                            this.activeclass,
                            7500
                        );

                        return;
                    }

                    break;

                //turn
                case "turn":
                    if (this.editbooking.turndata.data === "") {
                        //Render Response Message
                        responseMessage.renderResponseMessages(
                            this.$refs.responsebasemessage,
                            "warning",
                            "Os dados enviados não são válidos",
                            this.activeclass,
                            7500
                        );

                        return;
                    }

                    //Set turndata
                    let turndata =
                        this.customData.periodic_reservation.turns.find(
                            (value) =>
                                value.id === this.editbooking.turndata.data
                        );
                    this.editbooking.turndata.datahour.begin = turndata.begin;
                    this.editbooking.turndata.datahour.turn = turndata.id;

                    //Period Variable
                    switch(this.editbooking.turndata.datahour.turn){

                        case 3:
                            this.editbooking.turndata.datahour.end = this.editbooking.turndata.datahour.begin +
                                (this.customData.periodic_reservation.block_of_hour * 2);
                        break;

                        default:
                            this.editbooking.turndata.datahour.end = this.editbooking.turndata.datahour.begin +
                                this.customData.periodic_reservation.block_of_hour;
                        break;

                    }

                    break;

                default:
                    if (
                        this.editbooking.turndata.datahour.begin === null ||
                        this.editbooking.turndata.datahour.end === null
                    ) {
                        //Render Response Message
                        responseMessage.renderResponseMessages(
                            this.$refs.responsebasemessage,
                            "warning",
                            "Os dados enviados não são válidos",
                            this.activeclass,
                            7500
                        );

                        return;
                    }

                    break;
            }

            //Check totalhour
            if (
                this.editbooking.turndata.datahour.end -
                    this.editbooking.turndata.datahour.begin !==
                this.bookingReference.totalhour
            ) {
                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "warning",
                    "O total de horas deve ser igual a marcação original",
                    this.activeclass,
                    7500
                );

                return;
            }

            //Send Data
            this.sendData("edit");
        },
        appendElementConditional(
            typeoflocation,
            baseelement,
            firstselect = "select-turn-morning",
            secondselect = "select-turn-affternoon"
        ) {
            //Create Append Calendar Element
            calendarRoutine.createAppendElement(
                typeoflocation,
                baseelement,
                firstselect,
                secondselect
            );
        },
        dynamicGetSelectDate(element) {
            this.getSelectDate(
                element,
                "btnaddnewday",
                this.editbooking,
                "addnewweekday"
            );
        },
        getHourOrPeriodForAddNewDayReserve(element) {

            //Check Element
            if(element.target.hasAttribute('data-action') && element.target.getAttribute('data-action') === 'list'){

                //Show period turns
                calendarRoutine.showHideTurnList(element.target);
        
                return;

            }

            //Get Element
            calendarRoutine.dynamicUpdateSelectTurnId(element.target, "list-btnturn");

            //Check Element detail-reserve-list
            this.editbooking.turndata = calendarRoutine.setHourOrPeriod(
                this.editbooking.turndata,
                element.target
            );
        },
        getSelectDate(element, btnselect, reserverdata, trclassname) {
            //Check Element
            if (element.currentTarget.nodeName === "TD") {
                //Get All Dom Elements
                let spanElement = element.currentTarget.firstElementChild;
                let monthElement = element.currentTarget.offsetParent;

                //Check Day
                if (spanElement.textContent === "") {
                    return;
                }

                //Disable BTN
                document
                    .querySelector(`.${btnselect}`)
                    .setAttribute("disabled", true);

                //Get All Td Values
                let daysElementMonthList =
                    calendarRoutine.getAllElementsDayFromMonthCalendar(
                        [...monthElement.children],
                        trclassname
                    );

                //Select Days from Search Type
                calendarRoutine.dynamicStrucutureForSelectDaysFromSearchType(
                    reserverdata,
                    element.currentTarget,
                    spanElement,
                    daysElementMonthList,
                    this.interval,
                    this.customDays,
                    btnselect,
                    "reserver"
                );
            }
        },
        showModal(classname, bookingdata) {
            //Set Booking Reference
            Object.assign(this.bookingReference, bookingdata);

            //Set typeoflocation - 2 for turn and 1 for hour
            let typeoflocation = this.bookingReference.turn !== null ? 2 : 1;

            this.appendElementConditional(
                typeoflocation,
                "addnewdaychooselist",
                "select-turn-morning-addnewday",
                "select-turn-affternoon-addnewday"
            );

            //Set Copy for period select
            if(document.getElementById('list-btnturn')){

                document.getElementById('list-btnturn').textContent = 'Período';

                //Remove active class from btnturn
                calendarRoutine.removeActiveClassFromBtnTurn('addnewdaychooselist');

            }

            //Show Modal
            $(`.${classname}`).modal("show");
        },
        hideModal(classname) {
            //Clean data
            this.editbooking = {
                reserver: {},
                searchtype: 1,
                turndata: {
                    type: null,
                    datahour: {
                        begin: null,
                        end: null,
                    },
                    data: {},
                },
            };

            //Remove Old select
            [
                ...document.querySelector(".addnewdaychooselist").children,
            ].forEach((value) => value.remove());

            //Select Day Logic - Remove Class
            [...document.querySelectorAll(".addnewweekday")].forEach(
                (value) => {
                    //Remove Class
                    value.firstElementChild.classList.remove("selectday");
                }
            );

            //Hide Modal
            $(`.${classname}`).modal("hide");
        },
        setRequestDataByBooking(element) {
            //Check TurnData List
            if (this.pdpbookingdata.turndatalist.length === 1) {
                return;
            }

            //Get TurnDataList Reference
            let turndatahour =
                this.pdpbookingdata.turndatalist[
                    parseInt(
                        element.currentTarget.getAttribute("data-referindex")
                    )
                ];

            //Set Turn Booking Request Reference
            this.requestBookingTurnReference = `${turndatahour.begin}:00 - ${turndatahour.end}:00`;

            //Set related values for begin and end
            this.pdpbookingdata.data.begin = turndatahour.begin;
            this.pdpbookingdata.data.end = turndatahour.end;

            //Set Booking Id
            this.pdpbookingdata.booking_id = parseInt(
                element.currentTarget.getAttribute("data-bookingid")
            );

            //Remove old turnselected class
            [...document.querySelectorAll(".turnpdpitem")].forEach((value) =>
                value.classList.remove("turnselected")
            );

            //Add turnselected class
            element.currentTarget.classList.add("turnselected");
        },
        statusClassname(statusvalue) {
            let semAcento = statusvalue
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");

            return semAcento.toLowerCase().replace(" ", "-");
        },
        setCallbackMessage(indicate) {
            let message = "";

            switch (indicate) {
                case "current":
                case "old":
                    message = "Ainda não tem reservas";
                    break;

                case "cancel":
                    message = "Sem reservas canceladas";
                    break;
            }

            return message;
        },
        setBookingData(indicate) {
            return this.$data[`${indicate}Booking`];
        },
        cleanFilter() {
            //Get All Buttons
            let activeButton = [
                ...document.querySelectorAll(".module-button"),
            ].find((value) => value.classList.contains("activebk"));

            //Button Action
            let action = activeButton.getAttribute("data-action");

            //Disabled Button Filter
            this.disabledfilter = true;

            if (
                this.filterData.length === 0 &&
                this.$data[`${action}referBookingData`].length > 0
            ) {
                //Set Default Content
                this.$data[`${action}Booking`] =
                    this.$data[`${action}referBookingData`];

                return;
            }

            this.filterData = [];

            this.dateInputValue = "";

            //Conditional for turn back booking data
            this.$data[`${action}Booking`] =
                this.$data[`${action}referBookingData`];

            //Enabled Button Click
            [...document.querySelectorAll(".module-button")].forEach((value) =>
                value.classList.remove("disabledclick")
            );
        },
        filterValueByDate(element) {
            //Get All Buttons
            let activeButton = [
                ...document.querySelectorAll(".module-button"),
            ].find((value) => value.classList.contains("activebk"));

            //Button Action
            let action = activeButton.getAttribute("data-action");

            if (Object.values(this.$data[`${action}Booking`]).length === 0) {
                this.filterData = [];

                return;
            }

            //Disabled Button Click
            [...document.querySelectorAll(".module-button")].forEach((value) =>
                value.classList.add("disabledclick")
            );

            this.filterSelected.dateInputValue = Date.parse(
                this.dateInputValue
            );

            this.filterData = [];

            this.$data[`${action}Booking`].forEach((valbooking) => {
                let month =
                    valbooking.month < 10
                        ? `0${valbooking.month}`
                        : valbooking.month;
                let day =
                    valbooking.day < 10 ? `0${valbooking.day}` : valbooking.day;

                if (
                    this.filterSelected.dateInputValue ===
                    Date.parse(`${valbooking.year}-${month}-${day}`)
                ) {
                    this.filterData = this.filterConfirmPush(
                        this.filterData,
                        valbooking
                    );
                }
            });

            if (this.filterData.length > 0) {
                this.disabledfilter = false;

                this.$data[`${action}referBookingData`] = [];

                this.$data[`${action}referBookingData`] =
                    this.$data[`${action}Booking`];
            } else {
                this.disabledfilter = true;

                //Enabled Button Click
                [...document.querySelectorAll(".module-button")].forEach(
                    (value) => value.classList.remove("disabledclick")
                );

                //Clean Input date and show message
                if (element.target.value) {
                    this.dateInputValue = "";

                    this.disabledfilter = false;

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        "warning",
                        "Sem dados para apresentar",
                        this.activeclass
                    );

                    return;
                }

                if (
                    this.filterData.length === 0 &&
                    this.$data[`${action}referBookingData`].length === 0
                ) {
                    this.$data[`${action}referBookingData`] =
                        this.$data[`${action}Booking`];

                    return;
                }
            }

            //Conditional for turn back booking data
            this.$data[`${action}Booking`] =
                this.filterData.length > 0
                    ? this.filterData
                    : this.$data[`${action}referBookingData`];
        },
        filterConfirmPush(filterData, valbooking) {
            if (filterData.length === 0) {
                filterData.push(valbooking);
            } else {
                let confirmpush = filterData.find(
                    (valdata) => valdata.booking_id === valbooking.booking_id
                );

                if (confirmpush === undefined) {
                    filterData.push(valbooking);
                }
            }

            return filterData;
        },
        showHideRequest(element) {
            //Get Response | Request Element
            let responseElement = element.currentTarget.nextElementSibling;

            //Get Icon element
            let iconelemnt = [...element.currentTarget.children].find(
                (value) => value.nodeName === "IMG"
            );

            if (responseElement.classList.contains("d-none")) {
                //Show
                responseElement.classList.remove("d-none");

                //Change src
                iconelemnt.setAttribute(
                    "src",
                    `${this.defaultpathimg}/keyboard_arrow_up__blue.svg`
                );
            } else {
                //Hide
                responseElement.classList.add("d-none");

                //Change src
                iconelemnt.setAttribute(
                    "src",
                    `${this.defaultpathimg}/keyboard_arrow_down_blue.svg`
                );
            }
        },
        getRequestStatus(statusid) {
            //Get Type of request
            let request = this.requeststatus.find(
                (value) => value.id === statusid
            );

            return request.value;
        },
        formResponse(feddback_data) {
            //Find when response from Feedback
            let responseFeedback = feddback_data.find(
                (value) => !value.not_response_form
            );

            //Check response Feedback
            if (responseFeedback !== undefined) {
                return "* Sua solicitação obteve uma resposta";
            }

            return;
        },
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        inputValidationCase(inputid, element) {
            //Check Empty Values
            if (element.target.value === "") {
                //Disabled Button
                this.disabledspecialrequest = true;

                return;
            }

            //Check Inputs
            switch (inputid) {
                //message
                case "message":
                    if (this.message !== "" && this.message.length <= 400) {
                        this.disabledspecialrequest =
                            inputValidation.validNameCases(4, this.message)
                                ? false
                                : true;
                    }

                    break;
            }

            //Show Error Message
            if (this.disabledspecialrequest) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );
            }
        },
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        feedbackButtons(element) {
            let feedbackcase =
                element.currentTarget.getAttribute("data-action");

            //Feedback Action
            switch (feedbackcase) {
                //Experience
                case "experience":
                    //Remove Active Class
                    [...document.querySelectorAll(".feedbackitens")].forEach(
                        (value) => value.classList.remove("active")
                    );

                    //Add Active Class
                    element.currentTarget.classList.add("active");

                    //Set Feedback Value
                    this.feedbackdata.data[feedbackcase] = parseInt(
                        element.currentTarget.getAttribute("data-value")
                    );

                    //Enabled Submit Button
                    this.disabled = false;

                    break;

                //recommend, described, cleaned
                case "recommend":
                case "described":
                case "cleaned":
                    //Remove Class from Previus ou NextElement Sibling
                    if (element.currentTarget.nextElementSibling !== null) {
                        element.currentTarget.nextElementSibling.classList.remove(
                            "active"
                        );
                    }

                    if (element.currentTarget.previousElementSibling !== null) {
                        element.currentTarget.previousElementSibling.classList.remove(
                            "active"
                        );
                    }

                    //Add Active Class
                    element.currentTarget.classList.add("active");

                    //Set Feedback Value
                    this.feedbackdata.data[feedbackcase] = parseInt(
                        element.currentTarget.getAttribute("data-value")
                    );

                    //Enabled Submit Button
                    this.disabled = false;

                    break;

                //features
                case "features":
                    let featuredata =
                        this.feedbackFeauturesQuestion[
                            parseInt(
                                element.currentTarget.getAttribute("data-value")
                            )
                        ];

                    //Add List of Feautures
                    if (this.feedbackdata.data[feedbackcase].length === 0) {
                        this.feedbackdata.data[feedbackcase].push(featuredata);
                    } else {
                        if (
                            !this.feedbackdata.data[feedbackcase].includes(
                                featuredata
                            )
                        ) {
                            this.feedbackdata.data[feedbackcase].push(
                                featuredata
                            );
                        } else {
                            let index =
                                this.feedbackdata.data[feedbackcase].indexOf(
                                    featuredata
                                );

                            //Remove Feauture
                            this.feedbackdata.data[feedbackcase].splice(
                                index,
                                1
                            );
                        }
                    }

                    //Enabled Submit Button
                    if (this.feedbackdata.data[feedbackcase].length > 0) {
                        this.disabled = false;
                    }

                    break;
            }
        },
        resumeMessage(text, limit) {
            //console.log(text);
            if (text !== undefined) {
                let resume =
                    text.length > limit ? `${text.substr(0, limit)}...` : text;

                return resume;
            }
        },
        buttonsActions(element) {
            if (!Object.getOwnPropertyNames(this.bookingData).includes("old")) {
                return;
            }

            //Add Active class
            this.buttonsActionsStructure(
                element.target.getAttribute("data-action")
            );
        },
        buttonsActionsStructure(action) {
            //Check Booking Data
            if (
                !Object.hasOwn(this.bookingData, "current") &&
                !Object.hasOwn(this.bookingData, "old")
            ) {
                return;
            }

            //Check Content
            if (
                Object.values(this.bookingData.current).length === 0 &&
                Object.values(this.bookingData.old).length === 0
            ) {
                return;
            }

            //Show edit container
            switch (action) {
                case "current":
                    this.showeditcontainer = true;
                    break;

                default:
                    this.showeditcontainer = false;
                    break;
            }

            //Add Active class
            [...document.querySelectorAll(".module-button")].forEach(
                (value) => {
                    //Remove class
                    value.classList.remove("activebk");

                    if (value.getAttribute("data-action") === action) {
                        //Add class
                        value.classList.add("activebk");
                    }
                }
            );

            //Show Content
            [...document.querySelectorAll(".booking-content")].forEach(
                (value) => {
                    //Remove class
                    value.classList.add("desactivebk");

                    if (value.getAttribute("data-action") === action) {
                        //Add class
                        value.classList.remove("desactivebk");
                    }
                }
            );
        },
        showBookingDetails(element) {
            //Get Action
            let action = element.currentTarget.getAttribute("data-action");

            //Set Turn Back Content Reference
            this.referenceturnbackcontent = action;

            //Get Index
            let index = element.currentTarget.getAttribute("data-referindex");

            //Set Pdp Booking Data
            this.pdpbookingdata.id =
                this.$data[`${action}Booking`][index].office_id;
            this.pdpbookingdata.booking_id =
                this.$data[`${action}Booking`][index].booking_id;
            this.pdpbookingdata.manage_booking_id =
                this.$data[`${action}Booking`][index].manage_booking_id;
            this.pdpbookingdata.date = `${
                this.$data[`${action}Booking`][index].day
            } de ${
                this.customData.calendardata.allmonths[
                    `${this.$data[`${action}Booking`][index].month}`
                ]
            }`;
            this.pdpbookingdata.month =
                this.$data[`${action}Booking`][index].month;
            this.pdpbookingdata.year =
                this.$data[`${action}Booking`][index].year;
            this.pdpbookingdata.day = this.$data[`${action}Booking`][index].day;
            this.pdpbookingdata.address =
                this.$data[`${action}Booking`][index].office_address;
            this.pdpbookingdata.name =
                this.$data[`${action}Booking`][index].office_name;
            this.pdpbookingdata.image =
                this.$data[`${action}Booking`][index].image[0].media_original;

            //Set Pdp Booking Details
            Object.assign(
                this.pdpbookingdata.data,
                this.$data[`${action}Booking`][index].turndata
            );

            //Set Pdp Booking Turndatalist
            this.pdpbookingdata.turndatalist =
                this.$data[`${action}Booking`][index].turndatalist;

            //Set Turn Booking Request Reference - Default
            this.requestBookingTurnReference = `${this.pdpbookingdata.turndatalist[0].begin}:00 - ${this.pdpbookingdata.turndatalist[0].end}:00`;

            //Associated Content
            this.pdpbookingdata.typeofbooking = action;

            //Check Action
            switch (action) {
                //OldBooking
                case "old":
                    this.pdpbookingdata.feedback_response =
                        this.pdpbookingfeedbackrefer.office_id.includes(
                            this.pdpbookingdata.id
                        ) &&
                        this.pdpbookingfeedbackrefer.days.includes(
                            this.pdpbookingdata.day
                        )
                            ? true
                            : this.$data[`${action}Booking`][index]
                                  .feedback_response;

                    break;

                //CurrentBooking
                case "current":
                    this.pdpbookingdata.response_request =
                        this.$data[`${action}Booking`][index].feddback_data;

                    //Check by more then one hour in turndatalist
                    if (this.pdpbookingdata.turndatalist.length > 1) {
                        let responseRequestByTurn = [];

                        this.bookingData[action].forEach((value) => {
                            this.pdpbookingdata.turndatalist.forEach(
                                (valturn) => {
                                    if (
                                        (value.booking_id ===
                                            valturn.booking_id) &
                                        Array.isArray(value.feddback_data)
                                    ) {
                                        value.feddback_data.forEach(
                                            (valrequest) => {
                                                responseRequestByTurn.push(
                                                    valrequest
                                                );
                                            }
                                        );
                                    }
                                }
                            );
                        });

                        this.pdpbookingdata.response_request =
                            responseRequestByTurn.length > 0
                                ? responseRequestByTurn
                                : null;
                    }

                    break;
            }

            //Conditional for show Pdp Content
            this.showpdpbooking = true;
        },
        turnBack() {
            //Conditional for show Pdp Content
            this.showpdpbooking = false;

            if (document.querySelector(".booking-list")) {
                //Transiction Booking Content
                this.buttonsActionsStructure(this.pdpbookingdata.typeofbooking);
            }
        },
        sendData(routine) {
            //Disabled Button
            this.disabled = true;
            this.disabledspecialrequest = true;
            this.disablededitbooking = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Data Form
            let dataForm = {};

            //Request Data
            let urlRequest = this.feedbackurl;
            let method = "POST";

            //Check Routine
            switch (routine) {
                //feedback
                case "feedback":
                    //Set Data
                    this.feedbackdata.data.office_name =
                        this.pdpbookingdata.name;
                    this.feedbackdata.office_id = this.pdpbookingdata.id;
                    this.feedbackdata.booking_id =
                        this.pdpbookingdata.booking_id;
                    this.feedbackdata.data.booking.day =
                        this.pdpbookingdata.day;
                    this.feedbackdata.data.booking.date =
                        this.pdpbookingdata.date;
                    this.feedbackdata.data.booking.begin =
                        this.pdpbookingdata.data.begin;
                    this.feedbackdata.data.booking.end =
                        this.pdpbookingdata.data.end;
                    this.feedbackdata.data.booking.month =
                        this.pdpbookingdata.month;
                    this.feedbackdata.data.booking.year =
                        this.pdpbookingdata.year;

                    //Put Feddback Reference
                    this.pdpbookingfeedbackrefer.office_id.push(
                        this.feedbackdata.office_id
                    );
                    this.pdpbookingfeedbackrefer.days.push(
                        this.feedbackdata.data.booking.day
                    );

                    Object.assign(dataForm, this.feedbackdata);

                    break;

                //special_request
                case "special_request":
                    //Check Message
                    if (
                        this.subject === "" ||
                        this.message === "" ||
                        (this.message !== "" && this.message.length > 400)
                    ) {
                        //Render Response Message
                        responseMessage.renderResponseMessages(
                            this.$refs.responsebasemessage,
                            "danger",
                            "Por favor informar dados válidos para o campo mensagem",
                            this.activeclass
                        );

                        //Desactive Loading
                        document
                            .querySelector(".loadingbase")
                            .classList.remove("d-flex");

                        return;
                    }

                    //Set Data
                    dataForm.data = {
                        subject: this.subject,
                        message: this.message,
                        office_name: this.pdpbookingdata.name,
                        booking: {
                            day: this.pdpbookingdata.day,
                            date: this.pdpbookingdata.date,
                            month: this.pdpbookingdata.month,
                            year: this.pdpbookingdata.year,
                            begin: this.pdpbookingdata.data.begin,
                            end: this.pdpbookingdata.data.end,
                        },
                    };

                    dataForm.type =
                        parseInt(this.subject) === 1
                            ? "special_request"
                            : "cancellation";
                    dataForm.office_id = this.pdpbookingdata.id;
                    dataForm.booking_id = this.pdpbookingdata.booking_id;

                    break;

                //edit booking
                case "edit":
                    //Set Request
                    urlRequest = this.editurl;
                    method = "PUT";

                    dataForm = {
                        office_id: this.pdpbookingdata.id,
                        booking_id: this.bookingReference.booking_id,
                        reference_data: {
                            day: this.pdpbookingdata.day,
                            year: this.pdpbookingdata.year,
                            month: this.pdpbookingdata.month,
                            turndata: {
                                begin: this.bookingReference.begin,
                                end: this.bookingReference.end,
                            },
                        },
                        data: {
                            day: this.editbooking.reserver.day,
                            year: this.editbooking.reserver.year,
                            month: this.editbooking.reserver.month,
                            turndata: {
                                end: this.editbooking.turndata.datahour.end,
                                turn: this.editbooking.turndata.datahour.turn,
                                begin: this.editbooking.turndata.datahour.begin,
                                subtotal: this.bookingReference.subtotal,
                                totalhour:
                                    this.editbooking.turndata.datahour.end -
                                    this.editbooking.turndata.datahour.begin,
                            },
                        },
                    };

                    break;
            }

            //Send Data
            let response = fetchData.structureTosendData(
                urlRequest,
                dataForm,
                this.csrftolken,
                method
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Clean Object
                    switch (routine) {
                        //feedback
                        case "feedback":
                            this.feedbackdata = {
                                data: {
                                    experience: "",
                                    recommend: "",
                                    described: "",
                                    cleaned: "",
                                    features: [],
                                    booking: {
                                        day: "",
                                        date: "",
                                        begin: "",
                                        end: "",
                                    },
                                },
                                type: "feedback",
                                office_id: "",
                                booking_id: "",
                            };

                            //Redirect after Timout
                            setTimeout(() => {
                                //Redirect for Index
                                this.turnBack();
                            }, this.responseTimeOut);

                            break;

                        //special_request
                        case "special_request":
                            this.subject = "";
                            this.message = "";

                            //Redirect after Timout
                            setTimeout(() => {
                                //Reload Page
                                window.location.reload();
                            }, this.responseTimeOut);

                            break;

                        //edit
                        case "edit":
                            this.editbooking = {
                                reserver: {},
                                searchtype: 1,
                                turndata: {
                                    type: null,
                                    datahour: {
                                        begin: null,
                                        end: null,
                                    },
                                    data: {},
                                },
                            };

                            //Close Modal
                            this.hideModal("editbookingmodal");

                            //Select Day Logic - Remove Class
                            [
                                ...document.querySelectorAll(".addnewweekday"),
                            ].forEach((value) => {
                                //Remove Class
                                value.firstElementChild.classList.remove(
                                    "selectday"
                                );
                            });

                            if (value.classname === "success") {
                                //Update Booking Data on Current List
                                this.currentBooking.map((valbooking) => {
                                    if (
                                        valbooking.booking_id ===
                                            dataForm.booking_id &&
                                        valbooking.day ===
                                            dataForm.reference_data.day &&
                                        valbooking.month ===
                                            dataForm.reference_data.month &&
                                        valbooking.year ===
                                            dataForm.reference_data.year
                                    ) {
                                        valbooking.day = dataForm.data.day;
                                        valbooking.month = dataForm.data.month;
                                        valbooking.month_name =
                                            this.customData.calendardata.allmonths[
                                                `${dataForm.data.month}`
                                            ];
                                        valbooking.year = dataForm.data.year;
                                        valbooking.turndata.begin =
                                            dataForm.data.turndata.begin;
                                        valbooking.turndata.end =
                                            dataForm.data.turndata.end;

                                        valbooking.turndatalist.map(
                                            (valturn) => {
                                                if (
                                                    valturn.booking_id ===
                                                    dataForm.booking_id
                                                ) {
                                                    valturn.begin =
                                                        dataForm.data.turndata.begin;
                                                    valturn.end =
                                                        dataForm.data.turndata.end;
                                                }

                                                return valturn;
                                            }
                                        );
                                    }

                                    return valbooking;
                                });

                                //console.log(dataForm);

                                //Hide Pdp
                                this.showpdpbooking = false;

                                //Redirect after Timout
                                setTimeout(() => {
                                    //Reload Page
                                    window.location.reload();
                                }, this.responseTimeOut / 2);
                            }

                            break;
                    }

                    //Enabled Button
                    //this.disabled = false;
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;
                    this.disabledspecialrequest = false;
                    this.disablededitbooking = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
        openDatePicker() {
            const input = this.$refs.dateInput;
            if (!input) return;

            // p/ browser moderno
            if (typeof input.showPicker === "function") {
                input.showPicker();
            } else {
                // p/ browser antigo
                input.focus();
            }
        },
    },
    computed: {
        computedShowPdpBooking() {
            return this.showpdpbooking;
        },
        computedPdpBooking() {
            return this.pdpbookingdata;
        },
        computedPdpBookingFeedbackRefer() {
            return this.pdpbookingfeedbackrefer;
        },
    },
    watch: {
        computedShowPdpBooking() {},
        computedPdpBooking() {},
        computedPdpBookingFeedbackRefer() {},
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
        modal: Modal,
        calendarElement: CalendarElement,
    },
    beforeDestroy() {
        //Remove Session Storage
        //sessionStorage.removeItem('mobileconditional');
    },
};
</script>
